module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-3-6ecf79dbb9a59248510d64773993254e.jpg";